import React, { useState, useEffect } from 'react';
import firebase from '../../Firebase/firebaseConnection';
import Header from '../../Static/Header';
import NextStockTitleMark from '../../components/NextStockTitleMark';
import Video from './Video';
import './Youtube.css';

import { useTranslation } from "react-i18next";

export default function Youtube({ setPage }) {

  const { t, i18n } = useTranslation();

  const [videos, setVideos] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    // 🔹 Subscribe to YouTube videos
    const videosRef = firebase.database().ref('Youtube');

    const listener = videosRef.on('value', (snapshot) => {
      const videoList = [];
      snapshot.forEach((item) => {
        videoList.push({ key: item.key, link: item.val().link });
      });

      // Most recent first
      setVideos([...videoList].reverse());
    });

    return () => {
      videosRef.off('value', listener);
    };
  }, []);

  const visibleVideos = showAll ? videos : videos.slice(0, 3);

  return (
    <div className="youtube-container">

      <Header setPage={setPage} />

      <div className="ns-channel-heading"><div className="ns-channel-heading-copy"><span>THE NEXT STOCK CHANNEL</span><h1>Market insights, on demand.</h1><p>Explore the latest Next Stock video episodes.</p></div><NextStockTitleMark className="ns-channel-heading-logo" /></div>
      <div className="video-list">
        {visibleVideos.map((item) => (
          <Video key={item.key} data={item} />
        ))}
      </div>

      {videos.length > 3 && (
        <div className="video-list-controls">
          {!showAll ? (
            <button
              className="show-more-videos-btn"
              onClick={() => setShowAll(true)}
            >
              {t("youtube.showMore")}
            </button>
          ) : (
            <button
              className="show-more-videos-btn"
              onClick={() => setShowAll(false)}
            >
              {t("youtube.showLess")}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
